import { FaHandsHelping } from "react-icons/fa";
import ServiceRow from "./ServiceRow";
import './PrvaPomos.css'
export default function PrvaPomosh() {
  return (
    <ServiceRow
    id='prva-pomos'
      icon={<FaHandsHelping />}
      title="Обука за прва помош на работно место"
    >
      <p className="intro-text">
        Обука за прва помош на работно место претставува клучен дел од системот за безбедност и здравје при работа,
        со цел навремена реакција при повреди, несреќи и акутни здравствени состојби кај вработените.
      </p>

      <p className="intro-text">
        Во согласност со законските обврски и принципите на медицината на трудот, работодавачите се должни да обезбедат
        обучен кадар кој може да укаже прва помош до пристигнување на итната медицинска служба.
      </p>

      {/* 2x2 GRID */}
      <div className="system-packages-grid">

        <div className="system-package-card">
          <h5>🎯 Цел на обуката</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Зголемување на безбедноста на работното место</li>
            <li><span className="check">✓</span> Намалување на ризикот од сериозни последици при повреди</li>
            <li><span className="check">✓</span> Развивање на практични вештини за брза и ефективна интервенција</li>
            <li><span className="check">✓</span> Подобрување на организациската подготвеност при итни ситуации</li>
            <li><span className="check">✓</span> Едукација во рамки на службите по медицина на труд</li>
          </ul>
        </div>

        <div className="system-package-card">
          <h5>📚 Содржина на обуката</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Основни принципи на прва помош</li>
            <li><span className="check">✓</span> Проценка на состојба на повреден</li>
            <li><span className="check">✓</span> Кардиопулмонална реанимација (CPR)</li>
            <li><span className="check">✓</span> Употреба на AED дефибрилатор</li>
            <li><span className="check">✓</span> Запирање на крварење</li>
            <li><span className="check">✓</span> Фрактури, изгореници, труења</li>
            <li><span className="check">✓</span> Итни состојби (срцев и мозочен удар)</li>
          </ul>
        </div>

        <div className="system-package-card">
          <h5>⏱️ Времетраење и типови</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Основна обука: ~2 часа</li>
            <li><span className="check">✓</span> Напредна обука: 6–8 часа</li>
            <li><span className="check">✓</span> Обновителни (refresher) обуки</li>
            <li><span className="check">✓</span> On-site или едукативен центар</li>
            <li><span className="check">✓</span> Мали групи за поголема ефективност</li>
          </ul>
        </div>

        <div className="system-package-card">
          <h5>👨‍⚕️ Спроведување</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Специјалисти по медицина на труд</li>
            <li><span className="check">✓</span> Лекари и медицински персонал</li>
            <li><span className="check">✓</span> Сертифицирани инструктори</li>
            <li><span className="check">✓</span> Овластени здравствени институции</li>
          </ul>
        </div>
        <div className="system-package-card">
          <h5>📜 Сертификација</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Сертификат за обученост за прва помош</li>
            <li><span className="check">✓</span> Евиденција за инспекциски надзор</li>
            <li><span className="check">✓</span> Официјално признаена обука</li>
          </ul>
        </div>

        <div className="system-package-card">
          <h5>💼 За кого е наменета?</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Компании од сите индустрии</li>
            <li><span className="check">✓</span> Производство, градежништво, логистика</li>
            <li><span className="check">✓</span> Канцелариски и IT компании</li>
            <li><span className="check">✓</span> Образовни и здравствени институции</li>
          </ul>
        </div>

      </div>
      {/* BOTTOM SECTION */}
      <div className="mini-card full-width">
        <h4>📌Зошто е важна?</h4>
        <div className="pill-list">
          <span>Првата помош може да спаси живот</span>
          <span>Навремената реакција е критична во првите минути</span>
          <span>Ги намалува последиците од несреќи</span>
          <span>Ја зголемува безбедноста на работното место</span>
          <span>Го подобрува системот и организациската култура</span>
        </div>
      </div>
    </ServiceRow>
  );
}